/**
 * Personal-org detection.
 *
 * A personal org ("Personal Workspace") is auto-created by flameback-platform
 * for a user who belongs to zero IMS orgs; it has no other members, so user
 * management is meaningless there and is hidden in the UI. There is no org
 * `type` for this — personal orgs are identified purely by their id suffix.
 *
 * Mirrors flameback-platform `app/auth/auth_utils.py`
 * (`PERSONAL_ORG_SUFFIX` / `is_personal_org`) — keep the two in sync.
 */
export const PERSONAL_ORG_SUFFIX = '@PersonalOrg';

/** True when `orgId` is a personal org id (ends with `@PersonalOrg`). */
export function isPersonalOrg(orgId?: string | null): boolean {
  return orgId?.endsWith(PERSONAL_ORG_SUFFIX) ?? false;
}
